module.exports = __webpack_public_path__ + "media/images/bg/mosaic/doki-doki-8ada3862e3002bcbe5cea8c0fc544f13.jpg";